import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import { Badge, Col, Row, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import { getGreekCurrencyFormat, isEmpty } from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Button from "react-bootstrap/Button";
import Dropdown from "../../../primer/Dropdown";
import { dejavuSans } from "../../../../fonts/DejaVuSans-normal";
import { dejavuSansBold } from "../../../../fonts/DejaVuSans-Bold-bold";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import * as XLSX from "xlsx";
import BootstrapDropdown from "react-bootstrap/esm/Dropdown";
import { setVatInfoReportRequestData, setVatInfoReportResponseData } from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {useTranslation} from "../../../../hooks/useTranslation";

const vatCodeDescriptions = {
    "301": "Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (13%)",
    "302": "Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (6%)",
    "303": "Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (24%)",
    "331": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (13%)",
    "332": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (6%)",
    "333": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: Ι. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ σε λοιπή Ελλάδα εκτός από τα νησιά Αιγαίου. (24%)",
    "304": "ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (9%)",
    "305": "ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (4%)",
    "306": "ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (17%)",
    "334": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (9%)",
    "335": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (4%)",
    "336": "ΦΟΡΟΣ ΕΚΡΟΩΝ που αναλογεί: ΙΙ. ΕΚΡΟΕΣ, ΕΝΔΟΚ. ΑΠΟΚΤΗΣΕΙΣ & ΠΡΑΞΕΙΣ ΛΗΠΤΗ στα νησιά Αιγαίου και από λοιπή Ελλάδα προς τα νησιά αυτά (17%)",
    "307": "ΣΥΝΟΛΟ ΦΟΡΟΛ/ΤΕΩΝ ΕΚΡΟΩΝ",
    "337": "ΣΥΝ. ΦΟΡ.",
    "342": "Ενδοκοινοτικές παραδόσεις",
    "345": "Ενδοκ/τικές παροχές υπηρεσιών άρθρ. 14.2.α",
    "348": "Εξαγωγές & απαλλαγές πλοίων & αεροσκαφών",
    "349": "Λοιπές εκροές χωρίς ΦΠΑ με δικαίωμα έκπτωσης",
    "310": "Εκροές απαλ/νες & εξαιρ/νες χωρίς δικαίωμα έκπτωσης",
    "311": "ΣΥΝΟΛΟ ΕΚΡΟΩΝ",
    "312": "Κύκλος εργασιών ΦΠΑ",
    "361": "Αγορές & δαπάνες στο εσωτερικό της χώρας",
    "362": "Αγορές & εισαγωγές επενδ. αγαθών (πάγια)",
    "363": "Λοιπές εισαγωγές εκτός επενδ. αγαθών (πάγια)",
    "364": "Ενδοκοινοτικές αποκτήσεις αγαθών",
    "365": "Ενδοκοινοτικές λήψεις υπηρεσιών άρθρ. 14.2.α",
    "366": "Λοιπές πράξεις λήπτη",
    "367": "ΣΥΝΟΛΟ ΦΟΡΟΛ/ΤΕΩΝ ΕΙΣΡΟΩΝ",
    "381": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Αγορές & δαπάνες στο εσωτερικό της χώρας",
    "382": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Αγορές & εισαγωγές επενδ. αγαθών (πάγια)",
    "383": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Λοιπές εισαγωγές εκτός επενδ. αγαθών (πάγια)",
    "384": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Ενδοκοινοτικές αποκτήσεις αγαθών",
    "385": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Ενδοκοινοτικές λήψεις υπηρεσιών άρθρ. 14.2.α",
    "386": "ΦΟΡΟΣ ΕΙΣΡΟΩΝ: Λοιπές πράξεις λήπτη",
    "387": "ΣΥΝΟΛΟ ΦΟΡΟΥ ΕΙΣΡΟΩΝ",
    "400": "Επιστροφή φόρου αρ.41 (πωλ. αγρ. προϊοντ. x 3%)",
    "402": "Λοιπά προστιθέμ. ποσά",
    "407": "Ποσά διακανονισμών προς έκπτωση προηγούμενης διαχειριστικής περιόδου",
    "410": "ΠΡΟΣΤΙΘΕΜΕΝΑ ΠΟΣΑ ΣΤΟ ΣΥΝΟΛΟ ΤΟΥ ΦΟΡΟΥ ΕΙΣΡΟΩΝ",
    "411": "ΦΠΑ εισροών που πρέπει να μειωθεί βάσει ProRata",
    "422": "Λοιπά αφαιρούμενα ποσά",
    "423": "Ποσά διακανονισμών προς καταβολή προηγούμενης διαχειριστικής περιόδου",
    "428": "ΑΦΑΙΡΟΥΜΕΝΑ ΠΟΣΑ ΑΠΟ ΤΟ ΣΥΝΟΛΟ ΤΟΥ ΦΟΡΟΥ ΕΙΣΡΟΩΝ",
    "430": "ΥΠΟΛΟΙΠΟ ΦΟΡΟΥ ΕΙΣΡΟΩΝ",
    "470": "ΠΙΣΤΩΤΙΚΟ ΥΠΟΛΟΙΠΟ",
    "480": "ΧΡΕΩΣΤΙΚΟ ΥΠΟΛΟΙΠΟ",
    "401": "Πιστωτικό υπόλοιπο προηγ. φορολ. περιόδου",
    "483": "Χρεωστικό μέχρι 30€ προηγ. φορολ. περιόδου",
    "403": "Βεβαιωμένα ποσά κωδ.511 προηγ. δηλώσεων της ίδιας φορ. περιόδου",
    "505": "ΠΟΣΟ που σας επιστράφηκε ή ζητήσατε την επιστροφή του",
    "404": "Φόρος που έχει δεσμευτεί μέσω τραπεζών",
    "502": "ΠΟΣΟ για έκπτωση",
    "511": "ΠΟΣΟ προς καταβολή",
    "503": "ΑΙΤΟΥΜΕΝΟ ΠΟΣΟ για επιστροφή",
    "523": "Καταβολή ποσού κωδ. 511 σε 2 δόσεις",
    "507": "ΑΙΤΙΑ ΕΠΙΣΤΡΟΦΗΣ",
    "508": "ΑΙΤΗΣΗ ΣΥΜΨΗΦΙΣΜΟΥ του αιτούμενου προς επιστροφή ποσού με μελλοντικές οφειλές"
};

const getVatDescription = (vatKey) => {
    const numericCode = String(vatKey).replace(/\D/g, '');
    return vatCodeDescriptions[numericCode] || `Κωδικός ΦΠΑ ${numericCode} (Μη καταχωρημένη περιγραφή)`;
};

const renderCellContent = (value) => {
    const formatted = getGreekCurrencyFormat(value);
    const isHuge = Math.abs(value) >= 1000000;

    const textStyle = {
        fontSize: "0.7rem",
        fontWeight: "600",
        letterSpacing: "-0.4px"
    };

    if (isHuge) {
        const parts = formatted.split("€");
        const numberPart = parts.length > 1 ? parts[0].trim() : formatted;

        return (
            <div className="w-100 text-right d-flex flex-column align-items-end justify-content-center"
                 style={{...textStyle, lineHeight: "0.9"}}>
                <span className="text-truncate w-100">{numberPart}</span>
                <span style={{ fontSize: "0.55rem" }}>€</span>
            </div>
        );
    }

    return (
        <div className="text-truncate w-100 text-right" style={textStyle}>
            {formatted}
        </div>
    );
};

const AccountingReportVatInfo = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const requestData = useSelector((state) => state.ACCOUNTING_DATA.vatInfoReportRequestData);
    const responseData = useSelector((state) => state.ACCOUNTING_DATA.vatInfoReportResponseData);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const [iframeSrc, setIframeSrc] = useState();
    const iframeRef = React.createRef();

    const displayOptions = [
        { value: "false", label: "Εμφάνιση ανά παραστατικό" },
        { value: "true", label: "Εμφάνιση ανά ημέρα" }
    ];

    useEffect(() => {
        if (requestData?.firstLoad) {
            fetchReport(false, false);
        }
    }, [requestData?.firstLoad]);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true, false);
        }
    }, [pageChanged]);

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        dispatch(setVatInfoReportRequestData({ ...requestData, ...prepChange }));
    };

    const fetchReport = (fromPagination = false, forceRefresh = false) => {
        setLoading(true);
        const reqData = {
            ...requestData,
            firstLoad: false,
            page: (forceRefresh || !fromPagination) ? 1 : requestData.page,
        };

        dispatch(setVatInfoReportRequestData(reqData));

        axios.post(`${process.env.REACT_APP_API_URL2}/report/vat-information-report`, {
            ...reqData,
            company: company.id,
            forceRefresh: forceRefresh,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (res.data.filters?.lastUpdate) {
                    dispatch(setVatInfoReportRequestData({
                        ...reqData,
                        lastUpdate: res.data.filters.lastUpdate
                    }));
                }
                dispatch(setVatInfoReportResponseData({
                    ...res.data,
                    appliedGrouped: reqData.grouped_per_day
                }));
                if (forceRefresh) toast.success("Τα δεδομένα ανανεώθηκαν.");
            } else {
                if (forceRefresh) toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            if (!fromPagination) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    };

    const handlePage = (str) => {
        if (str === "first") {
            dispatch(setVatInfoReportRequestData({ ...requestData, page: 1 }));
            setPageChanged(true);
        } else if (str === "previous") {
            dispatch(setVatInfoReportRequestData({ ...requestData, page: requestData.page - 1 }));
            setPageChanged(true);
        } else if (str === "next") {
            dispatch(setVatInfoReportRequestData({ ...requestData, page: requestData.page + 1 }));
            setPageChanged(true);
        } else if (str === "last") {
            dispatch(setVatInfoReportRequestData({ ...requestData, page: responseData.totalPages }));
            setPageChanged(true);
        }
    };

    const handlePDFExport = async (printer = false) => {
        if (loading) return;
        setLoading(true);

        const currentGrouped = responseData.appliedGrouped || "false";

        const reqData = {
            ...requestData,
            grouped_per_day: currentGrouped,
            firstLoad: false,
            forExport: true,
            page: 1,
            company: company.id,
            forceRefresh: false
        };

        const response = await axios.post(`${process.env.REACT_APP_API_URL2}/report/vat-information-report`, reqData, { headers: { "Content-Type": "application/json" } })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });

        const expData = response.data?.data || [];
        const expColumns = response.data?.columns || [];
        const doc = new jsPDF('landscape');

        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
        doc.addFont("dejavusans.ttf", "DejaVuSans", "normal");
        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
        doc.addFont("dejavusansBold.ttf", "DejaVuSans", "bold");

        const pageWidth = doc.internal.pageSize.getWidth();
        const imgData = 'assets/images/prrimer-logo.png';
        const imgX = pageWidth - 45;
        doc.addImage(imgData, 'PNG', imgX, 5, 35, 12);

        let dateFrom = requestData.date_from || moment(company.year, "YYYY", true).startOf("year").format("DD/MM/YYYY");
        let dateTo = requestData.date_to || moment(company.year, "YYYY", true).endOf("year").format("DD/MM/YYYY");
        const headerText = currentGrouped === "true" ? "Αναφορά ΦΠΑ myDATA (Ανά Ημέρα)" : "Αναφορά ΦΠΑ myDATA (Ανά Παραστατικό)";
        const headerLines = doc.splitTextToSize(`${headerText} από ${dateFrom} έως ${dateTo}`, 200);

        doc.setFont("DejaVuSans", "bold");
        doc.setFontSize(11);
        doc.text(headerLines, 15, 8, { alignment: "left" });
        doc.setFont("DejaVuSans", "normal");
        doc.setFontSize(8);
        doc.text(`${company.name} | ΑΦΜ: ${company.vatNumber} | ΔΟΥ: ${companyDetails.doy || "-"}`, 15, 17, { alignment: "left" });
        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 15, 21, { alignment: "left" });

        const pdfHeaders = ["Αρ.", "Ημερομηνία"];
        if (currentGrouped === "false") pdfHeaders.push("MARK");
        expColumns.forEach(col => pdfHeaders.push(col.replace('Vat', '')));

        let rows = [];
        if (expData?.length > 0) {
            expData.forEach((row) => {
                let rowData = [
                    { content: String(row.no || ""), styles: { halign: "center" } },
                    { content: String(row.date || ""), styles: { halign: "center" } }
                ];

                if (currentGrouped === "false") {
                    rowData.push({ content: String(row.mark || "-"), styles: { halign: "center" } });
                }

                expColumns.forEach(col => {
                    rowData.push({ content: getGreekCurrencyFormat((row[col] || 0).toFixed(2)), styles: { halign: "right" } });
                });

                rowData.push({ content: getGreekCurrencyFormat((row.rowTotal || 0).toFixed(2)), styles: { halign: "right", fontStyle: "bold" } });
                rows.push(rowData);
            });
        }

        autoTable(doc, {
            startY: 25,
            head: [pdfHeaders],
            body: rows,
            rowPageBreak: "avoid",
            styles: {
                font: "DejaVuSans",
                fontStyle: "normal",
                fontSize: 7.5,
                cellPadding: 2,
            },
            headStyles: {
                font: "DejaVuSans",
                fontStyle: "bold",
                fillColor: [13, 110, 253],
                textColor: [255, 255, 255],
                halign: "center",
            },
        });

        const pageCount = doc.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFont("DejaVuSans", "normal");
            doc.setFontSize(8);
            doc.text(`Σελίδα ${i} από ${pageCount}`, 15, doc.internal.pageSize.getHeight() - 8);
        }

        if (printer) {
            setIframeSrc(`${doc.output('bloburl')}`);
        } else {
            doc.save("VatInfo-MyData.pdf");
        }
        setLoading(false);
    };

    const handleExcelExport = async () => {
        if (loading) return;
        setLoading(true);

        const currentGrouped = responseData.appliedGrouped || "false";

        const reqData = {
            ...requestData,
            grouped_per_day: currentGrouped,
            firstLoad: false,
            forExport: true,
            page: 1,
            company: company.id,
            forceRefresh: false
        };

        const response = await axios.post(`${process.env.REACT_APP_API_URL2}/report/vat-information-report`, reqData, { headers: { "Content-Type": "application/json" } })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });

        const expData = response.data?.data || [];
        const expColumns = response.data?.columns || [];

        let dR = [];
        if (expData?.length > 0) {
            expData.forEach((row) => {
                let obj = {
                    "Αρ.": row.no,
                    "Ημερομηνία": row.date,
                };

                if (currentGrouped === "false") {
                    obj["MARK"] = row.mark ? String(row.mark) : "-";
                }

                expColumns.forEach(col => {
                    const cleanColName = col.replace('Vat', '');
                    obj[cleanColName] = +(Number(row[col] || 0).toFixed(2));
                });
                dR.push(obj);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(dR, { raw: true });

        if (currentGrouped === "false") {
            Object.keys(worksheet).forEach(cell => {
                if (cell.startsWith('C') && cell !== 'C1') {
                    worksheet[cell].t = 's';
                    worksheet[cell].z = '@';
                }
            });
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "VatInfo_MyData.xlsx");
        setLoading(false);
    };

    const handleIframeLoad = () => {
        if (iframeSrc && iframeRef.current) {
            const iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.print();
        }
    };

    const vatCols = responseData?.columns || [];
    const hasMark = responseData?.appliedGrouped === "false";
    const fixedWidthSum = hasMark ? 45 : 27;
    const remainingWidth = 100 - fixedWidthSum;
    const dynamicColWidth = vatCols.length > 0 ? (remainingWidth / vatCols.length) : 0;
    const totalLeadColSpan = hasMark ? 3 : 2;

    return (
        <React.Fragment>
            <div style={{ display: "none" }} className="print-me" id="printReport">
                <iframe onLoad={() => handleIframeLoad()} ref={iframeRef} style={{ width: "100%" }} src={iframeSrc} title={"Print Report"}></iframe>
            </div>

            <Row className={"mb-2"}>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => dispatch(setVatInfoReportRequestData({
                            ...requestData,
                            date_from: from,
                            date_to: to
                        }))}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_from"}
                        selected={moment(requestData?.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : null}
                        label={t('SalesMyData.dateFrom')}
                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        allowOtherYears={false}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_to"}
                        selected={moment(requestData?.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : null}
                        label={t('SalesMyData.dateTo')}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        allowOtherYears={false}
                    />
                </Col>
                <Col md={3}>
                    {!isEmpty(requestData?.lastUpdate) && (
                        <Badge bg={"primary"} style={{ marginTop: "26px" }}>
                            Τελευταία ανανέωση από το My Data: <br />
                            {requestData.lastUpdate}
                        </Badge>
                    )}
                </Col>
                <Col md={3} className={"d-flex justify-content-end"}>
                    <Button onClick={() => fetchReport(false, true)} style={{ marginTop: "22px" }} disabled={loading}>
                        Άντληση Δεδομένων ΦΠΑ από το My Data {loading && <Spinner className={"ml-2"} animation="border" variant="dark" size="sm" />}
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col md={4}>
                    <Dropdown
                        name={"grouped_per_day"}
                        options={displayOptions}
                        label={"Τρόπος Εμφάνισης"}
                        defaultValue={displayOptions.find((el) => el.value === requestData?.grouped_per_day)}
                        onChange={(e) => handleOnChange(e, "dd", "grouped_per_day")}
                    />
                </Col>
                <Col md={8}>
                    <Button onClick={() => fetchReport(false, false)} className={"float-right"} disabled={loading} style={{ marginTop: "22px" }}>
                        Εφαρμογή φίλτρων {loading && <Spinner className={"ml-2"} animation="border" variant="dark" size="sm" />}
                    </Button>
                </Col>
            </Row>

            {responseData?.totalPages > 0 && (
                <React.Fragment>
                    <Row className="mt-3 align-items-center">
                        <Col className="d-flex justify-content-end">
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("first")}>{t('SalesMyData.first')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("previous")}>{t('SalesMyData.previous')}</Button>
                            <Badge style={{ fontSize: "12px", lineHeight: "20px" }} className="mr-1" bg="primary">
                                {t('SalesMyData.page')} {requestData.page} / {responseData.totalPages}
                            </Badge>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === responseData.totalPages} onClick={() => handlePage("next")}>{t('SalesMyData.next')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === responseData.totalPages} onClick={() => handlePage("last")}>{t('SalesMyData.last')}</Button>
                        </Col>
                    </Row>

                    <Row className={"mt-3"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableHoverable"} style={{ width: "100%", minWidth: "100%", tableLayout: "fixed" }}>
                                <colgroup>
                                    <col span={1} style={{ width: "2%" }}></col>
                                    <col span={1} style={{ width: "3%" }}></col>
                                    {hasMark && <col span={1} style={{ width: "4%" }}></col>}
                                    {vatCols.map(col => (
                                        <col key={`col-${col}`} span={1} style={{ width: `${dynamicColWidth}%` }}></col>
                                    ))}
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style={{fontSize: "0.75rem"}}>Αρ.</th>
                                    <th style={{fontSize: "0.75rem"}}>Ημερομηνία</th>
                                    {hasMark && <th style={{fontSize: "0.75rem"}}>MARK</th>}
                                    {vatCols.map((col, idx) => (
                                        <th key={idx} style={{fontSize: "0.75rem"}}>
                                            {col.replace('Vat', '')}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-${col}`}>
                                                        {getVatDescription(col)}
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="fa-solid fa-circle-info ml-1 text-primary" style={{ cursor: "pointer" }}></i>
                                            </OverlayTrigger>
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((row, idx) => (
                                    <tr key={`vatRow-${idx}`}>
                                        <td className="align-middle px-1" style={{ fontSize: "0.7rem" }}>
                                            {row.no}
                                        </td>
                                        <td className="align-middle px-1" style={{ fontSize: "0.7rem" }}>
                                            {row.date}
                                        </td>
                                        {hasMark && (
                                            <td className="align-middle px-1" style={{ fontSize: "0.7rem" }}>
                                                {row.mark || "-"}
                                            </td>
                                        )}
                                        {vatCols.map(col => {
                                            const cellValue = row[col] || 0;
                                            return (
                                                <td key={`${col}-${idx}`} className="px-1 align-middle" title={getGreekCurrencyFormat(cellValue)}>
                                                    {renderCellContent(cellValue)}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                            {responseData?.totals && (
                                <table
                                    className={"simpleClassicTable"}
                                    style={{
                                        width: "100%",
                                        minWidth: "100%",
                                        tableLayout: "fixed",
                                        marginTop: "16px"
                                    }}
                                >
                                    <colgroup>
                                        <col span={1} style={{ width: "2%" }}></col>
                                        <col span={1} style={{ width: "3%" }}></col>
                                        {hasMark && <col span={1} style={{ width: "4%" }}></col>}
                                        {vatCols.map(col => (
                                            <col key={`col-tot-${col}`} span={1} style={{ width: `${dynamicColWidth}%` }}></col>
                                        ))}
                                    </colgroup>
                                    <tbody>
                                    <tr style={{ backgroundColor: "#e9ecef" }}>
                                        <td
                                            colSpan={totalLeadColSpan}
                                            className="align-middle px-2 font-weight-bold"
                                            style={{ fontSize: "0.75rem", textAlign: "left" }}
                                        >
                                            Γενικά Σύνολα
                                        </td>
                                        {vatCols.map(col => {
                                            const cleanColName = col.replace('Vat', '');
                                            const totalVal = responseData.totals[cleanColName] !== undefined
                                                ? responseData.totals[cleanColName]
                                                : (responseData.totals[col] || 0);

                                            return (
                                                <td
                                                    key={`grand-total-${col}`}
                                                    className="px-1 align-middle font-weight-bold"
                                                    title={getGreekCurrencyFormat(totalVal)}
                                                >
                                                    {renderCellContent(totalVal)}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                    </tbody>
                                </table>
                            )}
                        </Col>
                    </Row>

                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <BootstrapDropdown className="mb-3 mt-2">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-export" disabled={loading}>
                                    Αποθήκευση αποτελεσμάτων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport(true)}>
                                        Εκτύπωση
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default AccountingReportVatInfo;